import { NotificationService, OptionsService } from '../../services';
import { Observable } from 'rxjs';
import { BaseCondition } from './base.condition';
import { ConditionFailReason } from '../../models';

export class ProactiveFormTagValidCondition extends BaseCondition {
    constructor(optionService: OptionsService, formTagName: string, notificationService: NotificationService) {
        super("ProactiveFormTagValidCondition", notificationService);
        this.observable = new Observable(observer => {
            if (!formTagName) {
                console.log("ProactiveFormTagValidCondition :: Passed as FormTag name was not defined in chat rule")
                observer.next(true);
                return;
            }
            optionService.getProactiveFormDetails("en", formTagName).subscribe(formData => {
                    if (formData && formData.tag && formData.tag === formTagName) {
                        console.log(`ProactiveFormTagValidCondition :: Passed as provided form tag ${formTagName} is valid`);
                        observer.next(true);
                        return;
                    }
                    this.onConditionFail(ConditionFailReason.ConfigurationError, `ProactiveFormTagValidCondition :: Failed as provided form tag ${formTagName} is invalid`)
                    observer.next(false);
                },
                err => {
                    this.onConditionFail(ConditionFailReason.ServerError, `ProactiveFormTagValidCondition :: Failed to get form for the form tag ${formTagName} due to error ${err}`);
                    observer.next(false);
                }
            )
        });
    }
}
